export const features = [
    {
        topic: "MEDICAL EMERGENCY",
        headline: "Get Instructions On Medical Emergency Situations",
        info: "Emken provides you with instructions and steps to follow for all kinds of medical emergency situations. Medical informations in emken were given by medical experts and health care professionals.",
        text: "Start Now",
        image: "emergency-one.png",
        url: "medical-emergency"
    },
    {
        topic: "FIND HOSPITAL",
        headline: "Get Locations To Medical Hospitals Around You",
        info: "Emken provides you with location and direction to medical hospitals incase of medical emergency situations.",
        text: "Find Now",
        image: "locate-one.png",
        url: "/"
    },
    {
        topic: "CHAT WITH DOCTOR",
        headline: "Get Advice From Medical Experts",
        info: "Emken provides you with the opportunity to chat with medical experts or practitioners on consultations and advice to follow during a medical emergency and trauma situations.",
        text: "Chat Now",
        image: "doctor-one.png",
        url: "chat-with-doctor"
    }
]